import { combineReducers, Reducer } from '@reduxjs/toolkit';
import modules from '@pages/modules/store';
import auth from '@features/auth/store';
import users from '@features/users/store';
import stands from '@pages/stands/store';
import teams from '@features/teams/store';
import common from '@features/favorites/store';
import { TagsState } from '@features/tags/store';
import { LibraryState } from '@pages/library/store';
import { BookingState } from '@pages/booking/store';
import { DashboardState } from '@pages/dashboards/store';
import { DefectsState } from '@pages/defects/store';

export type AsyncReducers = Partial<{
    tags: Reducer<TagsState>;
    testCases: Reducer<unknown>;
    library: Reducer<LibraryState>;
    booking: Reducer<BookingState>;
    dashboard: Reducer<DashboardState>;
    generator: Reducer<unknown>;
    profile: Reducer<unknown>;
    schemes: Reducer<unknown>;
    testPlans: Reducer<unknown>;
    testRuns: Reducer<unknown>;
    defects: Reducer<DefectsState>;
}>;

export const staticReducers = {
    modules: modules,
    auth: auth,
    users: users,
    stands: stands,
    common: common,
    teams: teams,
};

export const createRootReducer = (asyncReducers: AsyncReducers) => {
    return combineReducers({
        ...staticReducers,
        ...asyncReducers,
    });
};
